import { connect } from 'react-redux';
import React from 'react';

import PageSelector from 'components/PageSelector';
import { getChatPaging } from 'selectors';
import * as actions from 'actions';

const ChatResourcesPageSelector = props => <PageSelector {...props} />;

const mapStateToProps = state => getChatPaging(state, 'chatResources');

const mapDispatchToProps = dispatch => {
  return {
    onPrevClick: currentPage => {
      dispatch(actions.chatResourcesFetch(currentPage - 1));
    },
    onNextClick: currentPage => {
      dispatch(actions.chatResourcesFetch(currentPage + 1));
    },
    onPossiblePageUpdate: newPossiblePage => {
      dispatch(actions.chatResourcesUpdatePossiblePage(newPossiblePage));
    },
    onPageUpdate: (newPage, pagesCount) => {
      if(newPage >= 1 && newPage <= pagesCount) {
        dispatch(actions.chatResourcesFetch(newPage));
      }
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChatResourcesPageSelector);



/** WEBPACK FOOTER **
 ** ./src/members/Main/ChatResources/ChatResourcesPageSelector/index.js
 **/